"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { MeridianMark } from "@/components/ui/Micrographics";

function slugToTitle(slug: string): string {
  return slug.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
}

function usePathContext(): string | null {
  const pathname = usePathname();
  if (!pathname) return null;
  const segments = pathname.split("/").filter(Boolean);
  const section = segments[0];
  const brand = segments[1];

  if (section === "archive") {
    if (!brand || brand === "brands") return "Archive";
    if (brand === "designers" || brand === "directors") return "Designers";
    return slugToTitle(brand);
  }
  if (section === "designers") return "Designers";
  if (section === "search") return "Search";
  return null;
}

export default function SiteHeader() {
  const context = usePathContext();

  return (
    <header className="ws-nav">
      <Link href="/" className="logo-inline" style={{ textDecoration: "none" }}>
        <MeridianMark size={28} color="var(--ink)" sw={1.2} bg="var(--paper)" />
        <span className="text">
          wunder<em style={{ fontStyle: "italic", color: "var(--accent)" }}>look</em>
        </span>
        {context && (
          <span className="nav-context" style={{
            fontFamily: "var(--font-mono)", fontSize: 10, letterSpacing: "0.15em",
            textTransform: "uppercase", color: "var(--ink-3)", marginLeft: 6,
            whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "22ch",
          }}>
            / {context}
          </span>
        )}
      </Link>

      <ul>
        <li><Link href="/archive/brands">Archive</Link></li>
        <li><Link href="/archive/designers">Designers</Link></li>
        <li><Link href="/search">Search</Link></li>
      </ul>
    </header>
  );
}
